import { Component } from '@nicolas-riciotti/light2';
import Lenis from '../../helpers/Lenis'
import getPosition from '../../helpers/getPosition'

export default class BlockAboutHero extends Component {

    onScroll(e) {
        this._scroll = e.animatedScroll;
        const offset = this._scroll - this._top;
        if (this.$overlay) {
            this.$overlay.style.opacity = Math.min(1, Math.max(0, offset / (this._height * 0.5)));
        }
    }

    onResize() {
        this._top = getPosition(this).top;
        this._height = this.clientHeight;
    }

    created() {
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this._scroll = 0;
        this._top = 0;
        this._height = 0;
    }

    attached() {
        this.$overlay = this.querySelector('[data-fade-overlay]');
        Lenis?.on?.('scroll', this.onScroll);
        window.addEventListener('resize', this.onResize);
        this.onResize();
    }

}

customElements.define('block-about-hero', BlockAboutHero);
